import { Component, inject, Input, OnDestroy } from '@angular/core';
import { SvgPagePlaceholderComponent } from '@shared/components/svg-page-placeholder/svg-page-placeholder.component';
import { TranslateModule } from '@ngx-translate/core';
import { DisplayService } from '@core/services/display.service';
import { Subject, takeUntil } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-search-not-found-place-holder',
  templateUrl: './search-not-found-place-holder.component.html',
  styleUrls: ['./search-not-found-place-holder.component.scss'],
  standalone: true,
  imports: [SvgPagePlaceholderComponent, TranslateModule, NgClass],
})
export class SearchNotFoundPlaceHolderComponent implements OnDestroy {
  @Input() sm = false;
  isMobile: boolean;

  protected ngDestroy: Subject<void> = new Subject();
  private displayService = inject(DisplayService);

  constructor() {
    this.onWindowResize();
  }
  onWindowResize(): void {
    this.displayService
      .getBreakpointDeviceObserver()
      .pipe(takeUntil(this.ngDestroy))
      .subscribe((res) => {
        this.isMobile = res === 'mobile';
      });
  }

  ngOnDestroy(): void {
    this.ngDestroy.next();
    this.ngDestroy.complete();
  }

  get bgConfig() {
    if (this.isMobile || this.sm) {
      return { width: 250, height: 110, y: 8 };
    } else {
      return { width: 350, height: 180, y: 8 };
    }
  }

  get standConfig() {
    const config = {
      src: 'assets/images/pictograms/search.svg#search',
      height: '200',
      width: '200',
      x: '100',
      y: '4',
    };
    if (this.isMobile || this.sm) {
      config.width = '150';
      config.height = '130';
      config.x = '60';
    }
    return config;
  }
}
